import { ArrowBackRounded, ChevronRightRounded } from "@mui/icons-material";

import { Box, IconButton, Stack, Typography } from "@mui/material";

import { useNavigate, useOutletContext } from "react-router-dom";

import { mboSalePaymentDashboardServices } from "./data";

import { PageHero, pageContainerSx } from "./sharedStyles";

import SaleDataWorking from "./SaleDataWorking/SaleDataWorking";

import PaymentWorkingDashboard from "./Dashboard/PaymentWorkingDashboard";

import OfferChecker from "./Offers/OfferChecker";



function MboSalePaymentWorking() {

	const navigate = useNavigate();

	const [currentPath, service] = useOutletContext();



	const tabComponents = {

		[mboSalePaymentDashboardServices.sale_working.types.sale_data.key]: {

			...mboSalePaymentDashboardServices.sale_working.types.sale_data,

			component: <SaleDataWorking />,

		},

		[mboSalePaymentDashboardServices.sale_working.types.dashboard.key]: {

			...mboSalePaymentDashboardServices.sale_working.types.dashboard,

			component: <PaymentWorkingDashboard />,

		},

		[mboSalePaymentDashboardServices.sale_working.types.offers.key]: {

			...mboSalePaymentDashboardServices.sale_working.types.offers,

			component: <OfferChecker />,

		},

	};



	const activeTab = tabComponents?.[currentPath];



	return (

		<Box sx={pageContainerSx}>

			<Stack direction="row" alignItems="center" spacing={0.5} mb={2}>

				<IconButton

					size="small"

					onClick={() => navigate(-1)}

					sx={{ color: "text.secondary" }}

				>

					<ArrowBackRounded fontSize="small" />

				</IconButton>

				<Typography variant="caption" color="text.secondary">

					MBO Sale Payment Working

				</Typography>

				<ChevronRightRounded sx={{ fontSize: 16, color: "text.disabled" }} />

				<Typography variant="caption" fontWeight={600}>

					{service?.name}

				</Typography>

			</Stack>



			<PageHero

				icon={service?.icon}

				title={service?.name}

				description={service?.description}

			/>



			{activeTab?.component}

		</Box>

	);

}



export default MboSalePaymentWorking;

